import React from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Text} from '@vio/atlas/Text'

import {SIMILAR_HOTELS_LIMIT} from './constants'
import {SimilarHotelSkeleton} from './SimilarHotelSkeleton'
import {Section, SectionWrapper} from './styles'

export const SimilarHotelsCarouselLoading = () => {
  const {isDesktop} = useDeviceLayout()

  return (
    <SectionWrapper>
      <Section
        aria-busy
        aria-labelledby="anchor-similar-hotels-heading"
        data-testid="anchor-similar-hotels"
      >
        <Box
          paddingLeft={isDesktop ? 's700' : 's500'}
          paddingRight={isDesktop ? 's600' : 's500'}
          marginBottom="s400"
          display="flex"
          flexDirection="column"
          gap="s400"
        >
          <Text
            id="anchor-similar-hotels-heading"
            tag="h2"
            variant={isDesktop ? 'titleL' : 'titleM'}
          >
            <SkeletonLoader width={200} />
          </Text>
          <Text tag="div" variant={isDesktop ? 'bodyS' : 'bodyXS'}>
            <SkeletonLoader width={268} />
          </Text>
        </Box>
        <Box
          display="flex"
          gap="s400"
          paddingLeft={isDesktop ? 's600' : 's400'}
          paddingRight={isDesktop ? 's600' : 's400'}
          overflow="hidden"
          aria-hidden="true"
        >
          {Array.from({length: SIMILAR_HOTELS_LIMIT}, (_, index) => (
            <SimilarHotelSkeleton key={index} />
          ))}
        </Box>
      </Section>
    </SectionWrapper>
  )
}
